"use client";

import { createContext, useContext, useState } from "react";
import { PermissionsModal } from "../components/short-lp/permissions-modal";

interface PermissionsModalContextType {
	isOpen: boolean;
	openModal: () => void;
	closeModal: () => void;
}

const PermissionsModalContext = createContext<
	PermissionsModalContextType | undefined
>(undefined);

export function PermissionsModalProvider({
	children,
}: { children: React.ReactNode }) {
	const [isOpen, setIsOpen] = useState(false);

	const openModal = () => setIsOpen(true);
	const closeModal = () => setIsOpen(false);

	return (
		<PermissionsModalContext.Provider value={{ isOpen, openModal, closeModal }}>
			{children}
			<PermissionsModal open={isOpen} onOpenChange={closeModal} />
		</PermissionsModalContext.Provider>
	);
}

export function usePermissionsModal() {
	const context = useContext(PermissionsModalContext);
	if (context === undefined) {
		throw new Error(
			"usePermissionsModal must be used within a PermissionsModalProvider",
		);
	}
	return context;
}
